module.exports = __webpack_public_path__ + "img/insta.199c90d0.svg";